module.exports = __webpack_public_path__ + "static/media/Clock.d2cb92f2.svg";